import { useEffect, useState } from 'react';

export interface StorePack {
  id: string;
  slug: string;
  title: string;
  description: string | null;
  priceCents: number;
  productKey: string;
  metadata: { scenarioCount?: number } | null;
}

type State = { data?: StorePack[]; error?: Error; isLoading: boolean };

export function useStorePacks(): State {
  const [state, setState] = useState<State>({ isLoading: true });
  useEffect(() => {
    let cancelled = false;
    void fetch('/api/store/packs')
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`))))
      .then((body: { packs: StorePack[] }) => {
        if (!cancelled) setState({ data: body.packs, isLoading: false });
      })
      .catch((error: Error) => {
        if (!cancelled) setState({ error, isLoading: false });
      });
    return () => {
      cancelled = true;
    };
  }, []);
  return state;
}
